// src/pages/FinancialsPage.jsx
// SCREENER-FINANCIALS — unchanged this pass. Shell only, same discipline as
// FilingsPage.jsx: owns the useFinancialsOverview() fetch and layout —
// delegates all rendering to BiggestMovers.jsx / EstimatedUpcoming.jsx.

import React from 'react';
import { useFinancialsOverview } from '../hooks/useFinancialsOverview';
import BiggestMovers from '../components/financials/BiggestMovers';
import EstimatedUpcoming from '../components/financials/EstimatedUpcoming';

export default function FinancialsPage({ onNavigate }) {
  const { biggestMovers, estimatedUpcoming, loading, error } = useFinancialsOverview();

  return (
    <div>
      <div style={{ marginBottom: '1.25rem' }}>
        <h1 style={{ margin: 0, fontSize: '1.4rem', fontWeight: 900, color: '#f8fafc' }}>Financials</h1>
        <div style={{ fontSize: '0.8rem', color: '#64748b', marginTop: '0.2rem' }}>
          Computed fundamentals sourced directly from SEC XBRL filings.
        </div>
      </div>

      {loading && (
        <div style={{ textAlign: 'center', padding: '3rem', color: '#64748b' }}>Loading…</div>
      )}

      {error && (
        <div style={{ textAlign: 'center', padding: '3rem', color: '#ff4444' }}>{error}</div>
      )}

      {!loading && !error && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '1.5rem' }}>
          <BiggestMovers items={biggestMovers} onNavigate={onNavigate} />
          <EstimatedUpcoming items={estimatedUpcoming} />
        </div>
      )}
    </div>
  );
}
